import { Button } from '@cmctechnology/phoenix-stockbroking-web-design';
import styled from 'styled-components';

export const ReviewEditButton = styled(Button)`
  height: 2.5rem;
`;
